import { z } from 'zod';
/**
 * Schema for invoice item fields. Mirrors `public.invoice_items` columns.
 * `invoice_id` (FK NOT NULL) and `description` (text NOT NULL) are
 * required; everything else has a DB default or is nullable.
 *
 * `.passthrough()` lets future columns flow through instead of being
 * silently stripped (same defensive choice as priceBookItemSchema /
 * vendorSchema / invoiceSchema).
 *
 * `line_total` is modelled as nullable+optional because it's
 * server-computed via `calculateLineTotal` from `@prolarus/shared/finance`
 * when the caller doesn't send it (and on partial PUTs that change
 * `quantity`, `unit_price`, or `discount`).
 */
export const invoiceItemBaseSchema = z.object({
    invoice_id: z.string(),
    sequence: z.number().nullable().optional(),
    item_code: z.string().nullable().optional(),
    description: z.string().min(1),
    quantity: z.number().nullable().optional(),
    unit_price: z.number().nullable().optional(),
    uom: z.string().nullable().optional(),
    line_total: z.number().nullable().optional(),
    price_book_item_id: z.string().nullable().optional(),
    discount: z.number().nullable().optional(),
    external_system: z.string().nullable().optional(),
    external_system_record_id: z.string().nullable().optional(),
    quote_item_id: z.string().nullable().optional(),
}).passthrough();
/**
 * Schema for creating a new invoice item.
 */
export const invoiceItemCreateSchema = invoiceItemBaseSchema;
/**
 * Schema for updating an existing invoice item. All fields optional
 * (including `description`, which is required on create but may be
 * partially absent on PATCH-style updates).
 */
export const invoiceItemUpdateSchema = invoiceItemBaseSchema.partial();
//# sourceMappingURL=invoiceItemSchema.js.map